import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
  encodeURLParameterValueqlj48e6qtqd4 as encodeURLParameterValue,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UrlDecodedParametersBuilderClass;
function UrlDecodedParametersBuilder() {
  if (UrlDecodedParametersBuilderClass === VOID) {
    class $ {
      constructor(encodedParametersBuilder) {
        this.q5b_1 = encodedParametersBuilder;
        this.r5b_1 = this.q5b_1.s4t();
      }
      l38() {
        return decodeParameters(this.q5b_1);
      }
      s4t() {
        return this.r5b_1;
      }
      t4t(name) {
        var tmp0_safe_receiver = this.q5b_1.t4t(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().h2(collectionSizeOrDefault(tmp0_safe_receiver, 10));
          var _iterator__ex2g4s = tmp0_safe_receiver.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            var tmp$ret$2 = decodeURLQueryComponent(item, VOID, VOID, true);
            destination.i2(tmp$ret$2);
          }
          tmp = destination;
        }
        return tmp;
      }
      n4s(name) {
        return this.q5b_1.n4s(encodeURLParameter(name));
      }
      u4t() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.q5b_1.u4t();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = decodeURLQueryComponent(item);
          destination.i2(tmp$ret$2);
        }
        return toSet(destination);
      }
      n1() {
        return this.q5b_1.n1();
      }
      n4t() {
        return decodeParameters(this.q5b_1).n4t();
      }
      x4t(name, value) {
        return this.q5b_1.x4t(encodeURLParameter(name), encodeURLParameterValue(value));
      }
      y4t(stringValues) {
        return appendAllEncoded(this.q5b_1, stringValues);
      }
      o4t(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
        var _iterator__ex2g4s = values.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = encodeURLParameterValue(item);
          destination.i2(tmp$ret$2);
        }
        return this.q5b_1.o4t(tmp, destination);
      }
      a5() {
        return this.q5b_1.a5();
      }
    }
    initMetadataForClass($, 'UrlDecodedParametersBuilder');
    UrlDecodedParametersBuilderClass = $;
  }
  return UrlDecodedParametersBuilderClass;
}
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.l38();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.u4t().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.t4t(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = encodeURLParameterValue(item);
      destination.i2(tmp$ret$4);
    }
    _this__u8e3s4.o4t(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.u4t().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.t4t(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().h2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.i2(tmp$ret$4);
    }
    _this__u8e3s4.o4t(tmp, destination);
  }
}
//region block: exports
export {
  UrlDecodedParametersBuilder as UrlDecodedParametersBuilder18hwlye3pykgz,
  encodeParameters as encodeParameters1kx5voquz3xxo,
};
//endregion

//# sourceMappingURL=UrlDecodedParametersBuilder.mjs.map
